import type {
  AgentMemoryConfig,
  UpdateAgentMemoryConfigInput,
} from "schemas/generated/bedrock";
import type { RequestFn } from "./request";

export function createAgentMemoryConfigClient({
  request,
}: {
  request: RequestFn;
}) {
  return {
    update: ({
      projectId,
      ...input
    }: { projectId: string } & UpdateAgentMemoryConfigInput) => {
      return request<AgentMemoryConfig>({
        method: "PATCH",
        path: `/api/v1/projects/${projectId}/agent-memory-config`,
        body: input,
      });
    },
  };
}
